import { RectNode, RectNodeModel, h } from '@logicflow/core';
import { renderMarkers } from './markers';
import { renderWrappedText } from './textUtils';
import { getThemeStyle } from '../theme';

class ManualTaskView extends RectNode {
  getShape() {
    const { model } = this.props;
    const { x, y, width, height, radius } = model;
    const style = model.getNodeStyle();
    const props = model.properties || {};

    // Hand icon position (top-left corner)
    const ix = x - width / 2 + 6;
    const iy = y - height / 2 + 5;

    const children = [
      h('rect', {
        x: x - width / 2,
        y: y - height / 2,
        width,
        height,
        rx: radius,
        ry: radius,
        ...style,
      }),
      // BPMN Manual Task icon (simplified hand)
      h('path', {
        d: `M ${ix + 2} ${iy + 10} L ${ix + 2} ${iy + 5}
            C ${ix + 2} ${iy + 2} ${ix + 5} ${iy + 1} ${ix + 7} ${iy + 3}
            L ${ix + 7} ${iy + 1} C ${ix + 8} ${iy} ${ix + 10} ${iy + 1} ${ix + 10} ${iy + 3}
            L ${ix + 12} ${iy + 4} L ${ix + 12} ${iy + 10} Z`,
        fill: 'none',
        stroke: style.stroke,
        strokeWidth: 1.2,
      }),
    ];

    // Wrapped text inside the shape
    const label = (props && props.name) || '';
    if (label) {
      children.push(renderWrappedText(h, label, x, y + 4, width - 20, { graphModel: model.graphModel }));
    }

    children.push(...renderMarkers(x, y, width, height, props, style.stroke));

    return h('g', {}, children);
  }
}

class ManualTaskModel extends RectNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.width = 120;
    this.height = 60;
    this.radius = 5;
    this.text = { ...this.text, editable: false, draggable: false, value: '' };
  }


  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'manualTask');
    style.stroke = t.stroke || '#13c2c2';
    style.strokeWidth = t.strokeWidth ?? 1;
    style.fill = t.fill || '#e6fffb';
    return style;
  }
}

export const ManualTask = {
  type: 'epx:ManualTask',
  view: ManualTaskView,
  model: ManualTaskModel,
};
